// extracted by mini-css-extract-plugin
export var content = "_df-3";
export var list = "_df-4";
export var settingsContent = "_df-7";
export var settingsPanel = "_df-8";
export var state = "_df-6";
export var triggerBadge = "_df-2";
export var triggerButton = "_df-1";
export var triggerShell = "_df-0";
export var unreadDot = "_df-5";